var _rect, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcLocation(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1209_2234",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 20,
    height: 20
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_1209_2234)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.66667 10C10.2167 10 10.6877 9.804 11.0797 9.412C11.471 9.02067 11.6667 8.55 11.6667 8C11.6667 7.45 11.471 6.979 11.0797 6.587C10.6877 6.19567 10.2167 6 9.66667 6C9.11667 6 8.64601 6.19567 8.25467 6.587C7.86267 6.979 7.66667 7.45 7.66667 8C7.66667 8.55 7.86267 9.02067 8.25467 9.412C8.64601 9.804 9.11667 10 9.66667 10ZM9.66667 17.35C11.7 15.4833 13.2083 13.7873 14.1917 12.262C15.175 10.7373 15.6667 9.38333 15.6667 8.2C15.6667 6.38333 15.0873 4.89567 13.9287 3.737C12.7707 2.579 11.35 2 9.66667 2C7.98334 2 6.56234 2.579 5.40367 3.737C4.24567 4.89567 3.66667 6.38333 3.66667 8.2C3.66667 9.38333 4.15834 10.7373 5.14167 12.262C6.12501 13.7873 7.63334 15.4833 9.66667 17.35ZM9.66667 20C6.98334 17.7167 4.97934 15.5957 3.65467 13.637C2.32934 11.679 1.66667 9.86667 1.66667 8.2C1.66667 5.7 2.47101 3.70833 4.07967 2.225C5.68767 0.741667 7.55001 0 9.66667 0C11.7833 0 13.6457 0.741667 15.2537 2.225C16.8623 3.70833 17.6667 5.7 17.6667 8.2C17.6667 9.86667 17.0043 11.679 15.6797 13.637C14.3543 15.5957 12.35 17.7167 9.66667 20Z",
    fill: "#00BCE7"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcLocation);
export default __webpack_public_path__ + "static/media/ic-location.9b531930dcf121def68e272f8a0a762e.svg";
export { ForwardRef as ReactComponent };